var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-sound",class:{ 'v-sound_yellow': _vm.type == 'yellow' }},[_c('div',{staticClass:"video",class:{ 'video-close': _vm.playingMusic },on:{"click":_vm.toggleMusic}})])
}
var staticRenderFns = []

export { render, staticRenderFns }